import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { DateTime, Field, FormDialog, Select, TextArea } from 'core/form';
import { debounce } from 'lodash';
import { Position } from '@blueprintjs/core';

const fields = {
  message: {
    label: 'Message'
  },
  type: {
    label: 'Company'
  },
  expdate: {
    label: 'Expiration Date (UTC)'
  }
};

@inject('$sudo')
@observer
export default class CompanyMessagesFormDialog extends Component {
  asyncDebounce = (func, wait) => {
    const debounced = debounce((resolve, reject, args) => {
      func(...args)
        .then(resolve)
        .catch(reject);
    }, wait);
    return (...args) =>
      new Promise((resolve, reject) => {
        debounced(resolve, reject, args);
      });
  };

  handleCompanyQuery = this.asyncDebounce((term) => {
    const { $sudo } = this.props;

    const getSelectOptions = () => $sudo.companyCollection.selectOptions;
    return term && term.length >= 3
      ? $sudo.companyCollection.fetch({ query: { term } }).then(getSelectOptions)
      : Promise.resolve().then(getSelectOptions);
  }, 250);

  handleSave = (form, values) => {
    const { model, company, onClose } = this.props;

    return model
      .save(values)
      .then(() => {
        if (company) {
          return company.fetch();
        }
        return true;
      })
      .then(() => onClose());
  };

  handleRemove = () => {
    const { model, company, onClose } = this.props;

    return model
      .destroy()
      .then(() => {
        if (company) {
          return company.fetch();
        }
        return true;
      })
      .then(() => onClose());
  };

  render() {
    const { $sudo, model, onClose, showCompanyField } = this.props;

    return (
      <FormDialog
        isOpen
        model={model}
        onClose={onClose}
        entityName="Company Banner"
        fields={fields}
        options={{ name: 'Company Banner' }}
        width={600}
        formActionsProps={{
          onSubmit: this.handleSave,
          onCancel: onClose,
          onRemove: this.handleRemove,
          showRemove: true
        }}
      >
        <Field name="expdate">
          <DateTime
            popoverProps={{
              minimal: true,
              modifiers: {
                flip: { enabled: true, boundariesElement: 'viewport' },
                preventOverflow: { enabled: true, boundariesElement: 'window' },
                offset: { enabled: true, offset: '0, 8' }
              },
              position: Position.BOTTOM_RIGHT
            }}
          />
        </Field>
        {showCompanyField && (
          <Field name="type" onQuery={this.handleCompanyQuery} loading={$sudo.companyCollection.loading}>
            <Select fill showFilter />
          </Field>
        )}
        <Field name="message">
          <TextArea fill rows={3} />
        </Field>
      </FormDialog>
    );
  }
}
